import Button from 'atoms/Button/button';
import FormField from 'components/community/common/FormField';
import { StyledSvgSprite } from 'components/general/SVGSprite';
import { Box, FlexDiv } from 'components/molecules/utils/basicComponents';
import { Typography } from 'foundations/typography';
import React from 'react';
import styled from 'styled-components';
import { cdnImage } from 'utils/core';

export default function SocialLoungeTables(props) {
    const {
        onValueChange,
        isSocialTablesEnabled,
        state,
        errorMsg,
        value,
        handleNumberInput,
        title = 'Social lounge',
        handleIncrement,
        handleDecrement,
        onClose,
    } = props || {};
    return (
        <>
            <FlexDiv alignItems={'center'} mb={2} position={'relative'}>
                <Typography variant={'subtitle2'} color={'ambience.23'}>
                    {title}
                </Typography>
                <ButtonClose variant={'link'} onClick={onClose}>
                    <StyledSvgSprite
                        icon={'icon-times'}
                        height={'24px'}
                        width={'24px'}
                        fill={'ambience.23'}
                    />
                </ButtonClose>
            </FlexDiv>
            <Box mb={3} mt={4}>
                <SocialImg src={cdnImage('images/enable_social_lounge.svg')} />
            </Box>
            <Box mb={2}>
                <Typography mb={0} variant={'subtext1'} color={'ambience.23'}>
                    Give your participants the chance to interact with each
                    other
                </Typography>
                <Typography variant={'subtext2'} color={'ambience.14'}>
                    Increase engagement and activity by allowing participants to
                    meet and discuss on virtual tables in the social lounge
                </Typography>
            </Box>
            <FlexDiv alignItems={'center'} mb={3}>
                <ToggleButton>
                    <ToggleSwitch>
                        <StyledInput
                            onChange={() =>
                                onValueChange(
                                    'hasVirtualTables',
                                    !isSocialTablesEnabled
                                )
                            }
                            type='checkbox'
                            defaultChecked={isSocialTablesEnabled}
                        />
                        <SliderRound></SliderRound>
                    </ToggleSwitch>
                </ToggleButton>
                <FlexDiv flex={1}>
                    <ToggleButtonText
                        ml={'12px'}
                        variant={'subtext2'}
                        color={'ambience.14'}
                    >
                        {`Social lounge is ${
                            isSocialTablesEnabled ? '' : 'not '
                        }enabled for this event`}
                    </ToggleButtonText>
                </FlexDiv>
            </FlexDiv>
            {isSocialTablesEnabled && (
                <Box>
                    <FormField
                        type='text'
                        name={'tableCount'}
                        id={'tableCount'}
                        required
                        placeholder='Number of tables'
                        label='Number of tables'
                        min={1}
                        max={500}
                        maxLength={3}
                        size={3}
                        state={state}
                        errorMsg={errorMsg}
                        isError={!!errorMsg}
                        value={value}
                        onChange={() => {}}
                        onKeyPress={handleNumberInput}
                        // labelStyle={inputLabelStyle}
                        variant={'v2'}
                        hasButtons
                        subLabel={
                            'Choose how many tables are provided in the lounge.'
                        }
                        isLightBg
                        onDecrement={handleDecrement}
                        onIncrement={handleIncrement}
                    />

                    <Typography variant={'caption'} color='semantic.0'>
                        You can’t reduce the number of tables after the Airmeet
                        is created.
                    </Typography>
                </Box>
            )}
        </>
    );
}

const SocialImg = styled.img`
    height: 64px;
    width: 144px;
    max-width: 100%;
`;
const ToggleButton = styled(Box)``;
const ToggleButtonText = styled(Typography)``;
const StyledInput = styled.input``;
const SliderRound = styled.span`
    &:before {
        position: absolute;
        content: '';
        height: 20px;
        width: 20px;
        left: 2px;
        bottom: 1px;
        background-color: ${({ theme }) => theme.colors.ambience[0]};
        border: 1px solid ${({ theme }) => theme.colors.ambience[2]};
        -webkit-transition: 0.4s;
        -webkit-transition: 0.4s;
        transition: 0.4s ease-in-out;
        border-radius: 50%;
    }
`;
const ToggleSwitch = styled.label`
    position: relative;
    display: inline-block;
    width: 42px;
    height: 24px;
    margin: 0;
    ${StyledInput} {
        height: 0;
        width: 0;
        opacity: 0;
        &:checked + ${SliderRound} {
            background-color: ${({ theme }) => theme.colors.semantic[2]};
            border-color: ${({ theme }) => theme.colors.semantic[2]};
        }
        &:checked + ${SliderRound}:before {
            transform: translateX(16px);
        }
    }
    ${SliderRound} {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${({ theme }) => theme.colors.ambience[3]};
        border-radius: 34px;
        transition: 0.4s ease-in-out;
        border: 1px solid ${({ theme }) => theme.colors.ambience[6]};
    }
`;
const ButtonClose = styled(Button)`
    position: absolute;
    right: 0px;
    z-index: 1090;
    &:hover {
        opacity: 0.85;
    }
    &:focus {
        outline: 0;
        box-shadow: none;
    }
`;
